import Swiper from "swiper";
import { Mousewheel, Thumbs } from "swiper/modules";
import { createOfficesMap } from "../modules/offices/map.js";

const CURRENT_CLASS = "current";
const BTN_ACTIVE_CLASS = "site-btn--gradient";
const BTN_INACTIVE_CLASS = "site-btn--outlined";

// Серверная разметка помечает активный регион классами current / site-btn--gradient —
// после смены слайда переносим их на новый активный таб.
const updateRegions = ($items, activeIndex) => {
    $items.forEach(($item, index) => {
        const isActive = index === activeIndex;

        $item.classList.toggle(CURRENT_CLASS, isActive);

        const $btn = $item.querySelector(".site-btn");

        if ($btn) {
            $btn.classList.toggle(BTN_ACTIVE_CLASS, isActive);
            $btn.classList.toggle(BTN_INACTIVE_CLASS, !isActive);
        }
    });
};

const officesMapInit = () => {
    const $map = document.querySelector(".offices-page__map");
    const $data = document.getElementById("offices-map-data");
    let cities = [];

    try {
        cities = JSON.parse($data ? $data.textContent : "[]") || [];
    } catch (e) {
        cities = [];
    }

    return createOfficesMap($map, cities);
};

const officesSlidersInit = (onCityChange) => {
    const $regions = document.querySelector(".offices-page__regions");
    const $details = document.querySelector(".offices-page__details-slider");

    if (!$regions || !$details) {
        return;
    }

    const $items = Array.from($regions.querySelectorAll(".offices-page__regions-item"));

    // Регионы — thumbs-слайдер: centeredSlides держит активный таб по центру,
    // centeredSlidesBounds не даёт пустых краёв на первом/последнем слайде.
    const regionsSwiper = new Swiper($regions, {
        modules: [Mousewheel],
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: true,
        centeredSlidesBounds: true,
        watchSlidesProgress: true,
        // forceToAxis: обычное колесо оставляем странице, лента листается
        // только горизонтальной дельтой — shift+колесо или свайп по трекпаду
        mousewheel: {
            forceToAxis: true
        }
    });

    const detailsSwiper = new Swiper($details, {
        modules: [Thumbs],
        slidesPerView: 1,
        spaceBetween: 24,
        autoHeight: true,
        speed: 450, // помягче: вместе со слайдом анимируется и высота
        thumbs: {
            swiper: regionsSwiper
        },
        on: {
            init: (swiper) => updateRegions($items, swiper.activeIndex),
            slideChange: (swiper) => {
                updateRegions($items, swiper.activeIndex);
                // Модуль Thumbs лишь доводит активный таб до видимости —
                // докручиваем сами, чтобы он встал по центру (centeredSlides).
                regionsSwiper.slideTo(swiper.activeIndex);

                // Если табы за верхом экрана, после схлопывания высоты страница
                // оказалась бы в подвале — возвращаем табы в кадр
                if ($regions.getBoundingClientRect().top < 0) {
                    $regions.scrollIntoView({ behavior: "smooth", block: "start" });
                }

                if (onCityChange) {
                    onCityChange(swiper.activeIndex);
                }
            }
        }
    });

    // Шрифты грузятся позже DOMContentLoaded — без пересчёта ширины табов
    // остаются измеренными по fallback-шрифту и крайние слайды недокручиваются.
    if (document.fonts) {
        document.fonts.ready.then(() => {
            regionsSwiper.update();
            detailsSwiper.update();
            // update() выводит activeIndex из транслейта и может сместить ленту —
            // возвращаемся к реально выбранному табу
            regionsSwiper.slideTo(detailsSwiper.activeIndex, 0);
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const officesMap = officesMapInit();

    officesSlidersInit((index) => {
        if (officesMap) {
            officesMap.showCity(index);
        }
    });
});
